import React, { Component } from 'react'

import {TimelineMax, Expo} from 'gsap'

class Lines extends Component{
    componentDidMount()
    {

        const bar = document.getElementsByClassName('line')

        let tl = new TimelineMax()

        //setter
        tl.set(bar, {height: 0})

        //animation
        tl.staggerTo(bar, 2,
            {
                height: "100%",
                ease: Expo.easeOut
            }, 0.5);
    }

    render(){

        return(
            <div className="lines">
                <span className="line"></span>
                <span className="line"></span>
                <span className="line"></span>
            </div>
        )
    }
}

export default Lines


// WEBPACK FOOTER //
// ./src/components/common/Lines.js